import { useAtomValue } from 'jotai';
import { domain } from 'modules/data';
import { useSelector } from 'modules/react-redux';
import { netSuiteExpenseReportFieldValuesState } from 'pages/requestForm/containers/netsuite/NetSuiteExpenseReportRequestForm/NetSuiteExpenseReportRequestForm.states';
import { requestSelector } from 'pages/requestForm/selectors/pageSelectors';
import { getRequestEditMode } from 'pages/requestForm/selectors/requestSelectors';
import { getRuleTypeByEditMode } from 'pages/requestForm/utils/helpers';
import { useMemo } from 'react';
import { useGetNetSuiteLineCustomers } from 'shared/data/webApp/v1';

export const useCustomers = (query?: string) => {
    const { employee } = useAtomValue(netSuiteExpenseReportFieldValuesState);
    const request = useSelector(requestSelector);
    const editMode = useSelector((state) => getRequestEditMode(state, request));
    const ruleType = getRuleTypeByEditMode(editMode);

    const { data, isFetching } = useGetNetSuiteLineCustomers({
        query: {
            requestId: request.id,
            ruleType,
            query,
            startFrom: 0,
            rowNum: 20,
            companyId: request.companyId,
            entityId: employee?.id,
            sublistType: domain.DocumentSublistType.ExpenseList,
        },
    });

    const customers = useMemo(
        () => (data?.values ?? []).map((customer) => ({ ...customer, text: customer.name })),
        [data]
    );

    return {
        customers,
        isLoading: isFetching,
    };
};
